<template>
  <span class="wrapper">
    <span v-tooltip.bottom="{ content: tooltipContent }" :style="{ color: isRejected ? 'red' : 'inherit' }">
      {{ displayValue }}
      <i v-if="isRejected" class="fas fa-info-circle"></i>
    </span>
  </span>
</template>

<script>
  export default {
    computed: {
      isRejected() {
        return this.params.value.toLowerCase() === 'rejected' || this.params.value.toLowerCase() === 'declined'
      },
      displayValue() {
        return this.params.value === 'Rejected' ? 'Declined' : this.params.value
      },
      tooltipContent() {
        return !this.isRejected ? this.params.value : this.getRejectionReason()
      }
    },
    methods: {
      getRejectionReason() {
        return 'Decline Reason: ' + this.params.data.RejectionReason
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-cards/CardStatus.vue